import React, { Suspense, useEffect, memo, useMemo } from "react";
import config from "./moduleMap";
import loadable from "@loadable/component";
import { ErrorBoundary } from "react-error-boundary";
import logger from "./logger";
const Modules = loadable(() => import("./modules"));
const ModuleLoader = loadable(() => import("./components/ModuleLoader"));
function WrapperModule(props) {
    let { siteConfig, pagedata, moduleCount, browserDetails, pathName } = props;
    useEffect(() => {
        import("./helpers").then(({ handleUserLogInState }) => {
            handleUserLogInState();
        });
    }, [pagedata]);
    const WatchNewModules = memo(function _WatchModules() {
        return moduleCount > 4 ? (React.createElement(Modules, { siteConfig: siteConfig, pagedata: pagedata, offset: 4, moduleCount: moduleCount })) : null;
    }, (prevProps, nextProps) => prevProps["pathName"] === nextProps["pathName"]);
    const modules = useMemo(() => {
        return pagedata === null || pagedata === void 0 ? void 0 : pagedata.map((module) => {
            var _a;
            const moduleMap = ((_a = module === null || module === void 0 ? void 0 : module.layout) === null || _a === void 0 ? void 0 : _a.view) ? config.map[module.layout.view] : null;
            if (!moduleMap) {
                return logger(`Module not found for '${moduleMap}'`, "warn");
            }
            const Component = loadable(() => import(`./modules/${moduleMap}`), { ssr: true });
            return (React.createElement("div", { key: module.id },
                React.createElement(ErrorBoundary, { fallback: React.createElement("p", null, "Something went wrong") },
                    React.createElement(Suspense, { fallback: null },
                        React.createElement(Component, { browserDetails: browserDetails, siteConfig: siteConfig, moduleData: module })))));
        });
    }, [pagedata, browserDetails, siteConfig]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModuleLoader, null),
        modules,
        React.createElement(WatchNewModules, { ...props })));
}
export default memo(WrapperModule, (prevProps, nextProps) => {
    return prevProps.pagedata === nextProps.pagedata;
});
